"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const MixpanelHandler_1 = __importDefault(require("@becrop/components/Modules/Common/Models/MixpanelHandler"));
class Controller {
    constructor() {
        this.eventHandler = new MixpanelHandler_1.default();
    }
    trackEvent(eventName, eventProps) {
        /*         console.group("\x1b[34m%s\x1b[0m", `🛎️ Event Tracker: ${eventName}`);
                console.log(eventProps);
                console.groupEnd(); */
        this.eventHandler.trackEvent(eventName, eventProps);
    }
}
exports.default = Controller;
